import * as React from "react";
import GroupedAppointmentTypeList from "../../../GroupedAppointmentTypeList/v3/components/AppointmentTypeList/GroupedAppointmentTypeList/GroupedAppointmentTypeList.js";
import SingleAppointmentTypeList from "../../../SingleAppointmentTypeList/v3/components/AppointmentTypeList/SingleAppointmentTypeList/SingleAppointmentTypeList.js";
const AppointmentTypeList = ({
  className,
  appointmentDisplayType,
  appointmentTypes,
  groupedAppointmentTypes,
  appointmentTypeIcons,
  appointmentTypeToolTips,
  appointmentGlobalLabels,
  groupedAppointmentTypeToolTips,
  groupedAppointmentGlobalLabels,
  onClick,
  onClickToolTip,
  ...rest
}) => {
  return /* @__PURE__ */ React.createElement(React.Fragment, null, appointmentDisplayType === "single" && /* @__PURE__ */ React.createElement(
    SingleAppointmentTypeList,
    {
      ...rest,
      appointmentTypes,
      appointmentTypeIcons,
      appointmentTypeToolTips,
      appointmentGlobalLabels,
      onClick,
      onClickToolTip,
      className
    }
  ), appointmentDisplayType === "group" && /* @__PURE__ */ React.createElement(
    GroupedAppointmentTypeList,
    {
      groupedAppointmentTypes,
      groupedAppointmentTypeToolTips,
      groupedAppointmentGlobalLabels,
      onClick,
      onClickToolTip,
      className
    }
  ));
};
export {
  AppointmentTypeList as default
};
//# sourceMappingURL=AppointmentTypeList.js.map
